import React, { useState } from 'react'
// @ts-ignore
import { Accordion } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { CountTypeStrings } from 'enums/CountType'
import getInsightContent from 'components/insightContent/utils/getInsightContent'
import { InsightContentTypeStrings } from 'components/insightContent/enum/InsightContentType'
import { InsightContentSettingType } from 'components/insightContent/types'
import { MetricTimeUnitStrings } from 'enums/MetricTimeUnit'

type AccordionGroupType = {
  countType?: CountTypeStrings
  insightContentsConfig: Array<{
    accordionTitle: string
    accordionContents: Array<{
      insightContentType: InsightContentTypeStrings
      detailSetting: InsightContentSettingType | undefined
      renderNameMeasureTitleContent?: () => React.ReactNode
      widgetId?: number
      isAudienceQuery?: boolean
    }>
  }>
  timeUnits?: MetricTimeUnitStrings[]
  forceNotScale?: boolean
}

const AccordionGroup = ({
  countType,
  insightContentsConfig,
  timeUnits,
  forceNotScale
}: AccordionGroupType) => {
  const [expanded, setExpanded] = useState<number | false>(0)
  const theme = useDisplayTheme() as Theme

  const handleChange = (panel: number) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false)
  }

  const disabledExpandIcon = insightContentsConfig.length === 1 ? null : undefined
  const disableCollapseEvt = insightContentsConfig.length === 1

  return (
    <>
      {insightContentsConfig.map((accordionItem, index) => (
        <Accordion
          mode={theme}
          isExpanded={expanded === index}
          onChange={handleChange(index)}
          // eslint-disable-next-line react/no-array-index-key
          key={`accordion-${accordionItem.accordionTitle}-${index}`}
          testId={`accordion-${index}`}>
          <Accordion.AccordionSummary
            expandIcon={disabledExpandIcon}
            disablePointerEvents={disableCollapseEvt}
            // eslint-disable-next-line react/no-array-index-key
            key={`accordion-summary-${accordionItem.accordionTitle}-${index}`}
            testId={`accordion-summary-${index}`}>
            {accordionItem.accordionTitle}
          </Accordion.AccordionSummary>
          <>
            {accordionItem.accordionContents.map((content, idx) => (
              <Accordion.AccordionDetails
                // eslint-disable-next-line react/no-array-index-key
                key={`accordion-details-${content.insightContentType}-${idx}`}
                testId={`accordion-details-${idx}`}>
                {content?.detailSetting ? (
                  getInsightContent({
                    insightContentType: content.insightContentType,
                    detailSetting: content?.detailSetting,
                    countType,
                    timeUnits,
                    forceNotScale,
                    renderNameMeasureTitleContent: content?.renderNameMeasureTitleContent,
                    widgetId: content?.widgetId,
                    isAudienceQuery: content?.isAudienceQuery
                  })
                ) : (
                  <></>
                )}
              </Accordion.AccordionDetails>
            ))}
          </>
        </Accordion>
      ))}
    </>
  )
}

export default AccordionGroup
